import { Loader2 } from 'lucide-react'

export function PageLoader() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: '400px',
      }}
      role="status"
      aria-label="Loading page"
    >
      <div style={{ textAlign: 'center' }}>
        <Loader2
          size={32}
          style={{
            animation: 'spin 1s linear infinite',
            color: '#8b5cf6',
          }}
        />
        <p style={{ marginTop: '1rem', color: '#9ca3af' }}>Loading...</p>
      </div>
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  )
}

